import { BlockImage, T } from "@/site/Editable";

export const PageHead = ({ titleKey, introKey }) => (
  <section className="hs-pagehead hs-cream" data-testid="page-head">
    <T k={titleKey} as="h1" className="hs-pagehead__title hs-rise" multiline={false} />
    {introKey && <T k={introKey} className="hs-pagehead__intro hs-rise hs-d2" />}
  </section>
);

const Member = ({ id, flip }) => (
  <article className={`hs-member ${flip ? "is-flip" : ""}`} data-testid={`team-${id}`}>
    <BlockImage k={`about.${id}.image`} alt="Team member" className="hs-frame hs-frame--light hs-member__img hs-fade" />
    <div className="hs-member__text hs-fade">
      <T k={`about.${id}.role`} className="hs-eyebrow hs-eyebrow--dark" multiline={false} />
      <T k={`about.${id}.name`} as="h3" className="hs-member__name" multiline={false} />
      <T k={`about.${id}.bio`} className="hs-member__bio" />
    </div>
  </article>
);

export default function About() {
  return (
    <>
      <PageHead titleKey="about.heading" introKey="about.intro" />
      <section className="hs-band" data-testid="about-who-we-are">
        <div className="hs-ornament hs-ornament--top" aria-hidden="true" />
        <div className="hs-wrap hs-about">
          <T k="about.who.heading" as="h2" className="hs-title" multiline={false} />
          <div className="hs-about__cols">
            <div className="hs-fade">
              <T k="about.philosophy.heading" as="h3" className="hs-about__sub" multiline={false} />
              <T k="about.philosophy.body" className="hs-band__body" />
            </div>
            <div className="hs-fade">
              <T k="about.mission.heading" as="h3" className="hs-about__sub" multiline={false} />
              <T k="about.mission.body" className="hs-band__body" />
            </div>
          </div>
        </div>
        <div className="hs-ornament hs-ornament--bottom" aria-hidden="true" />
      </section>
      <section className="hs-cream hs-team" data-testid="about-team">
        <div className="hs-wrap">
          <T k="about.team.heading" as="h2" className="hs-title hs-title--dark" multiline={false} />
          <Member id="pm" />
          <Member id="designer" flip />
        </div>
      </section>
    </>
  );
}
